<template>
  <v-app>
    <v-data-table
      :page="page"
      :pageCount="numberOfPages"
      :options.sync="options"
      :server-items-length="totalItems"
      :headers="headers"
      :items="items"
      :search="search"
      :loading="loading"
      loading-text="Đang tải dữ liệu... Vui lòng chờ"
      :items-per-page="perPage"
      :footer-props="{
        showFirstLastPage: true
      }"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Tin cung cầu</v-toolbar-title>
          <v-badge
            v-if="userId"
            bordered
            left
            color="success"
            :content="countMsg ? countMsg : '0'"
            overlap
            offset-x="20"
            offset-y="20"
            class="mr-2"
          >
            <v-btn
              icon
              @click="showMessageDialog"
            >
              <v-icon>
                mdi-email-outline
              </v-icon>
            </v-btn>
          </v-badge>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Nhập từ khóa"
            class="shrink"
            single-line
            hide-details
          ></v-text-field>
          <v-spacer v-if="userId" ></v-spacer>
          <v-btn
            v-if="userId"
            color="primary"
            elevation="2"
            dark
            class="mb-2"
            v-on:click="showDialog()"
            :icon="$vuetify.breakpoint.lgAndUp ? false : true"
          >
            <span v-if="$vuetify.breakpoint.lgAndUp">thêm mới</span>
            <v-icon v-else>mdi-plus</v-icon>
          </v-btn>
          <slot name="message"></slot>
          <Form
            :showDialog="dialog" 
            :item="item" 
            :user="parseInt(userId)"
            @confirmed="onConfirmed" 
            @cancelled="onCancelled"
          />
          <Message 
            :showDialog="messageDialog" 
            :cosoId="parseInt(userId)"
            @confirmed="onMessageConfirmed" 
            @cancelled="onMessageCancelled"
          />
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="headline">Bạn có chắc bạn muốn xóa mục này?</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary darken-1" text @click="closeDelete">Hủy bỏ</v-btn>
                <v-btn color="pink darken-1" text @click="deleteItemConfirm">Đồng ý</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.id`]="{ index }">
        {{ (perPage * (page-1)) +  (index+1) }}
      </template>
      <template v-slot:item.anh_dai_dien="{ item }">
        <v-img
          v-if="item.anh_dai_dien"
          :src="`${apiBaseUrl}/uploads/${item.anh_dai_dien}`"
          class="ma-2"
          width="120"
        >
        </v-img>
        <v-img
          v-else
          src="@/assets/NoImage.jpg"
          class="ma-2"
          width="120"
        >
        </v-img>
      </template>
      <template v-slot:item.the_loai_id="{ item }">
        <v-chip
          class="ma-2"
          color="primary"
          outlined
          pill
          small
        >
          {{ item.the_loai_id==0 ? 'Người mua' : 'Người bán' }}
          <v-icon right small>
            mdi-account-arrow-{{ item.the_loai_id==0 ? 'left' : 'right' }}
          </v-icon>
        </v-chip>
      </template>
      <template v-slot:item.actions="{ item }">
        <div style="white-space: nowrap;">
          <v-btn
            icon
            color="primary"
            @click="editItem(item)"
          >
            <v-icon>
              mdi-pencil
            </v-icon>
          </v-btn>
          <v-btn
            icon
            color="pink"
            @click="deleteItem(item)"
          >
            <v-icon>
              mdi-delete
            </v-icon>
          </v-btn>
        </div>
      </template>
      <template v-slot:no-data>
        <v-btn
          color="primary"
          @click="initialize"
        >
          Tải lại
        </v-btn>
      </template>
    </v-data-table>
  </v-app>
</template>
<script>
  import Form from '@/views/admin/trades/Form';
  import Message from '@/views/admin/trades/Message';
  import { mapActions, mapState } from 'vuex';
  export default {
    components: {
      Form,
      Message
    },
    props: {
      userId: {
        type: Number,
        default: 0
      }
    },
    data: () => ({
      loading: false,
      dialog: false,
      dialogDelete: false,
      search: '',
      headers: [
        { text: 'STT', value: 'id' },
        { text: 'Ảnh', value: 'anh_dai_dien' },
        { text: 'Tiêu đề', value: 'tieu_de' },
        { text: 'Loại', value: 'the_loai_id' },
        { text: 'Ngày đăng', value: 'ngay_dang' },
        { text: 'Ngày hết hạn', value: 'ngay_het_han' },
        { 
          align: 'right', 
          text: 'Thao tác', 
          value: 'actions', 
          sortable: false 
        },
      ],
      page: 1,
      totalItems: 0,
      numberOfPages: 0,
      perPage: 10,
      items: [],
      editedIndex: -1,
      item: {},
      countByType: {
        t0: 0,
        t1: 0
      },
      options: {},
      btnActive: null,
      countMsg: 0,
      messageDialog: false,
    }),
    computed: {
      ...mapState([
        'config'
      ]),
      formTitle () {
        return this.editedIndex === -1 ? 'thêm mới' : 'Edit Item';
      },
      apiBaseUrl() {
        return this.config.beUrl;
      }
    },
    watch: {
      dialog (val) {
        val || this.close();
      },
      dialogDelete (val) {
        val || this.closeDelete();
      },
      options: {
        handler() {
          this.initialize();
        },
      },
      search(){
        this.initialize();
      }
    },
    mounted () {
      this.countMessageOfUser();
    },
    methods: {
      ...mapActions([
        'openSnackbar'
      ]),
      initialize() {
        const app = this;
        app.loading = true;
        const { page, itemsPerPage, type } = app.options;
        let pageNumber = page;
        let user = null;
        if(app.userId){
          user = app.userId;
        }
        let request = {
          params: {
            size: itemsPerPage,
            page: pageNumber,
            type: type,
            user: user,
            keyword: app.search
          }
        };
        axios.get("api/v1/trades", request)
          .then(response => {
            app.items = response.data.data;
            app.countByType.t0 = app.items.filter(
              c => c.the_loai_id == 0
            ).length;
            app.countByType.t1 = app.items.filter(
              c => c.the_loai_id == 1
            ).length;
            app.totalItems = response.data.total;
            app.numberOfPages = response.data.to;
            app.page = response.data.current_page;
            app.perPage = response.data.per_page;
            app.loading = false;
          })
          .catch(function (error) {
            app.openSnackbar({ type: 'error' });
          });
      },
      byType(type) {
        this.btnActive=type;
        this.options.type = type;
        this.initialize();
      },
      showDialog(item=null){
        this.item = item||{};
        this.dialog = true;
      },
      onConfirmed(item) {
        this.dialog = false;
        this.initialize();
      },
      onCancelled() {
        this.dialog = false;
      },
      editItem(item) {
        this.editedIndex = this.items.indexOf(item);
        this.item = Object.assign({}, item);
        this.dialog = true;
      },
      deleteItem(item) {
        this.editedIndex = this.items.indexOf(item);
        this.item = Object.assign({}, item);
        this.dialogDelete = true;
      },
      deleteItemConfirm() {
        var app = this;
        axios.delete(`api/v1/trades/${app.item.id}`)
          .then(function (resp) {
            app.items = app.items.filter(val => val.id !== app.item.id);
            app.closeDelete();
          }).catch(function (error) {
            console.log(error);
          });
      },
      close() {
        this.dialog = false;
        this.$nextTick(() => {
          this.item = Object.assign({}, this.item);
          this.editedIndex = -1;
        })
      },
      closeDelete() {
        this.dialogDelete = false;
        this.$nextTick(() => {
          this.item = Object.assign({}, this.item);
          this.editedIndex = -1;
        })
      },
      countMessageOfUser(){
        let user = 0;
        // nếu user = 0
        // có nghĩa là lấy hết
        // không theo 1 user nào cả
        if(this.userId){
          user = this.userId;
        }
        axios.get(`api/v1/get-message-by-user/${user}`)
          .then(response => {
            if(response.data){
              this.countMsg = response.data.length;
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      showMessageDialog(item=null){
        this.messageDialog = true;
      },
      onMessageConfirmed(item) {
        this.messageDialog = false;
      },
      onMessageCancelled() {
        this.messageDialog = false;
      },
    }
  }
</script>